// src/pages/ServicesPage.js
import React from 'react';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import './ServicesPage.css';
import IEDPNexed from '../assets/IEDPNexed.png';
import '../index.css'; 

const ServicesPage = () => {
  const services = [
    {
      id: 'primary-research-advisory',
      iconClass: 'fa-regular fa-square-poll-vertical', // Added icon class
      title: 'Primary Research',
      description:
        'Tailored, insight-driven research designed to address specific challenges, answer critical questions, optimize decision-making, and provide actionable intelligence aligned with your institution or organization’s unique needs.',
    },
    {
      id: 'positioning-brand-market-strategy',
      iconClass: 'fa-regular fa-chess-knight', // Added icon class
      title: 'Positioning, Brand & Market Strategy', // Using "&" for consistency with your nav data
      description:
        'Expert guidance and strategic insights to inform positioning, messaging, brand, and market strategy—helping business education brands engage audiences, grow globally, and unlock new opportunities.',
    },
    {
      id: 'content-marketing-thought-leadership',
      iconClass: 'fa-regular fa-icons', // Added icon class
      title: 'Content Marketing & Thought Leadership', // Using "&" for consistency with your nav data
      description:
        'Co-creating high-quality content, reports, and research-based thought-leadership to build brand trust, engagement, and authority.',
    },
  ];

  return (
    <>
      <main className="servicesPageContainer">
        {/* 1. Hero Element with Background Image and Text to the Left */}
        {/* The text is already in the h1 and p, CSS will position it */}
        <header className="servicesPageHeader">
          <h1>Services from the Experts Behind Nexed Insight</h1>
          <p>Brought to you by IEDP — Nexed’s founding team and parent company</p>
        </header>

        {/* 2. Intro Paragraph Section */}
        <section className="servicesIntroSection">
          <div className="ServicesImage">
                <img src={IEDPNexed} alt="IEDP & Nexed" />
              </div>
          <p>
            At Nexed Insight, our mission is to push the boundaries of insight in the business education sector. While Nexed is not a services provider, the in-depth research we conduct plays a pivotal role in powering the strategic services offered by our parent company, IEDP.
          </p>
          <p>
            Drawing on the intelligence, trends, and emerging perspectives surfaced through Nexed’s research, IEDP offers a suite of tailored services to help business education brands grow, differentiate, and lead in an evolving landscape.
          </p>
        </section>

        {/* Current list of services */}
        <section className="servicesList">
          {services.map((service) => (
            <article key={service.id} id={service.id} className="serviceItem">
              {/* Add the icon here */}
              {service.iconClass && (
                <div className="serviceIconWrapper">
                  <i className={`${service.iconClass} serviceIcon`}></i>
                </div>
              )}
              <h2 className="serviceTitle">{service.title}</h2>
              <p className="serviceDescription">{service.description}</p>
            </article>
          ))}
        </section>

        {/* Updated to use ContactForm */}
        <section className="servicesContactSection">
          {/* New header above the form */}
          <h2 className="contactHeaderTitle">Ready to turn insight into action?</h2>
          <p className="contactHeaderSubtitle">Reach out to IEDP using the form below—we’d love to hear from you.</p>
          <ContactForm />
        </section>

        <div className="footerFullWidth">
          <Footer />
        </div>
      </main>
    </>
  );
};

export default ServicesPage;